import { ContentState, convertFromRaw, convertToRaw, EditorState } from 'draft-js';
import { useEffect, useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

export default function AdminRTE({ component, onPropertyChange }) {

    let initialContent = component?.question;
    if (typeof initialContent === 'string' && (initialContent.startsWith("{" || initialContent.startsWith("[{]")))) initialContent = JSON.parse(initialContent); // For Old format need double parsing

    const [editorState, setEditorState] = useState(() => {
        if (initialContent) {
            try {
                return EditorState.createWithContent(convertFromRaw(initialContent));
            } catch {
                try {
                    return EditorState.createWithContent(ContentState.createFromText(initialContent));
                } catch {
                    console.warn("Failed to parse initial content for AdminRTE, using empty state.");
                    return EditorState.createEmpty();
                }
            }
        }
        return EditorState.createEmpty();
    });
    const [debounceTimeout, setDebounceTimeout] = useState(null);

    useEffect(() => {
        return () => {
            if (debounceTimeout) clearTimeout(debounceTimeout);
        };
    }, [debounceTimeout]);

    const handleEditorChange = (state) => {
        setEditorState(state);
        const value = JSON.stringify(convertToRaw(state.getCurrentContent()));
        if (debounceTimeout) clearTimeout(debounceTimeout);
        setDebounceTimeout(setTimeout(() => {
            if (onPropertyChange) onPropertyChange(value);
        }, 1000));
    };

    const handleBlur = () => {
        const value = JSON.stringify(convertToRaw(editorState.getCurrentContent()));
        if (onPropertyChange) onPropertyChange(value);
    };

    return (
        <div>
            <Editor
                editorState={editorState}
                onEditorStateChange={handleEditorChange}
                onBlur={handleBlur}
                toolbar={{ options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'colorPicker', 'link', 'emoji', 'remove', 'history'] }}
                wrapperClassName="wysiwyg-wrapper"
                editorClassName="wysiwyg-editor"
            />
        </div>
    );
}
